import { post } from '../utils/ApiUtil';
import type { GetUploadTicketParamDTO, OssUploadTicketDTO } from './OssType';

const mock = false;

const getUploadTicket = async (
  param: GetUploadTicketParamDTO,
): Promise<OssUploadTicketDTO | null> => {
  if (mock && false) {
    const ext = param.ext || 'jpg';
    const objectKey = `${param.scene}/category_${Date.now()}.${ext}`;
    return {
      uploadUrl: `https://mock-upload.local/${objectKey}`,
      objectKey,
      accessUrl: `https://yuanling-new.oss-cn-shanghai.aliyuncs.com/${objectKey}`,
      headers: { 'Content-Type': param.contentType || 'image/jpeg' },
    };
  }
  const result = await post<GetUploadTicketParamDTO, OssUploadTicketDTO>('/oss/getUploadTicket', param);
  if (typeof result === 'string') {
    return null;
  }
  return result;
};

export const OssApi = {
  getUploadTicket,
};
